<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >

    <v-row>
      <v-col
        v-for="wallet in currentwallets" :key="wallet.profilename"
        cols="12"
        sm="6"
        lg="3"
      >
                <v-card
                  class="mx-auto"
                  max-width="344"
                  outlined
                >
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="overline mb-4">{{wallet.profilename}}</div>
                      
                      <v-list-item-title class="headline mb-1">{{wallet.symbol}}</v-list-item-title>

                      <v-card-text class="headline">
                        Balance {{bal}}
                      </v-card-text>
                    </v-list-item-content>
               
                    <v-list-item-avatar
                      size="80"
                    >
                    <IconCrypto :coinname="wallet.symbol" color="color" format="svg" />
                    </v-list-item-avatar>
                  </v-list-item>

                  <v-card-actions>
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-qrcode">
                        Get QR Code
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-img src="/img/qrcode.png">
                          </v-img>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card-actions>
                  <v-card-actions>
                    <v-btn outlined color="primary">Details</v-btn>
                  </v-card-actions>
                </v-card>
      </v-col>  
                 
    

      <v-col
        sm="12"
        md="12"
      >
        <base-material-card
          color="transparent"
          hover-reveal
          image
        >
          <template v-slot:image>
            <v-img
              src="/img/wallet_pic.png"
              height="200"
            />
          </template>

          <template v-slot:reveal-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  
                  class="mx-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-view-split-vertical</v-icon>Read More
                </v-btn>
              </template>
              <span>View</span>
            </v-tooltip>
          </template>

          <v-card-title class="justify-center font-weight-light">
            Server Status
          </v-card-title>

          <v-card-text class="body-1 text-center mb-3 font-weight-light grey--text">
            Dashboard for all the server statuses in the network
          </v-card-text>

          <template v-slot:actions>
            <div class="display-2 font-weight-light grey--text">
       
            </div>

            <v-spacer />

            <span class="caption grey--text font-weight-light">
            </span>
          </template>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  const axios = require('axios')
  
  export default {
    name: 'Wallets',

    data () {
      return {
        bal: '',
        valid: true,
        result: '',
        addressrules : [
          v => !!v || 'Address is required'
        ],
        walletprofilerules : [
          v => !!v || 'A label is required'
        ],        
        address: '',
        error: '',
        dialog: false,
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,
        list: {
          0: false,
          1: false,
          2: false
        }
      }
    },
    timers: {
      log: { time: 300000, autostart: true, repeat: true }
    },
    computed: {  
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      }
    },
    created () {
    },
    methods: {
      log () {

      },
      reset () {
        this.dialog = false
      },
      logErrors (promise) {
        promise.catch(console.error)
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
